(function(){
    angular
        .module('appback')
        .directive('ngCalendariogastos', calendariogastos);

        calendariogastos.$inject = ['CalendariogastoService','$timeout','$uibModal','uiCalendarConfig'];
        function calendariogastos(CalendariogastoService,$timeout,$uibModal,uiCalendarConfig){
            return {
            templateUrl:'/backend/app/views/calendariogastos.html',
            scope: { url:"=",control:"=",calendar:"=" },
            //require: 'ngModel',
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
                	console.log(scope);
                    scope.events = [];
                    scope.cerrar = {};
                    scope.scanning = false;
                    scope.triggerUpload = function() {
                        document.getElementById('gasto-foto-input').value = "";
                        document.getElementById('gasto-foto-input').click();
                    };
                    scope.uploadFoto = function(element) {
                        var file = element.files[0];
                        if (!file) return;

                        $timeout(function() {
                            scope.scanning = true;
                        });

                        var reader = new FileReader();
                        reader.onload = function(e) {
                            var base64 = e.target.result;
                            CalendariogastoService.analizarFoto(base64, function(response) {
                                $timeout(function() {
                                    scope.scanning = false;
                                    if (response.success && response.data) {
                                        var info = response.data;
                                        scope.addCalaus(info);
                                        $timeout(function() {
                                            if (info.conceptogasto_id) {
                                                $('#conceptogasto_id').val(String(info.conceptogasto_id)).trigger('change');
                                            }
                                            if (info.pagogasto_id) {
                                                $('#pagogasto_id').val(String(info.pagogasto_id)).trigger('change');
                                            }
                                            if (info.concepto_texto && window.CKEDITOR && CKEDITOR.instances['concepto_texto']) {
                                                CKEDITOR.instances['concepto_texto'].setData(info.concepto_texto);
                                            }
                                        }, 400);
                                    } else {
                                        alert(response.message || "Error al escanear el ticket.");
                                    }
                                });
                            });
                        };
                        reader.readAsDataURL(file);
                    };
                    scope.eventSource = [{
                        //events:scope.events,
                        url: scope.url,
                        className: 'gcal-event',           // an option!
                        //currentTimezone: 'America/Chicago' // an option!
                    }];


                    scope.uiConfig = {
                      calendar:{
                        height: 550,
                        editable: false,
                        header:{
                          left: 'title',
                          center: '',
                          right: 'today prev,next'
                        },
                        firstDay:1,
                        eventClick: function(date, jsEvent, view){
                        	//console.log(date);
                        	//console.log(jsEvent);
                        	//console.log(view);
                            //scope.calendar.fullCalendar('refetchEvents');
                            scope.initPopup(date);
                            //console.log(date.id);
                        },
                        eventDrop: scope.calendarClick,
                        eventResize: scope.calendarClick,
                        eventRender: scope.calendarClick,
                        viewRender: function(view, element) {
                            scope.calendar = view.calendar;
                            var dateVar = new Date(view.calendar.getDate()._d);
                            var dayDate = 1;
                            var monthDate = dateVar.getMonth()+1;
                            var yearDate = dateVar.getFullYear();
                            var fecha = yearDate+"-"+monthDate+"-"+dayDate;
                            CalendariogastoService.revisarCierre(fecha,function(data){
                            	scope.cerrar = data;
                                console.log(data);
                            });
                            /*console.log(view);
                            console.log(view.calendar.getCalendar());
                            console.log(view.calendar.getCalendar());
                            console.log(view.calendar.getDate());
                            console.log(view.calendar.today());
                            console.log(view.calendar.moment());*/
                            //$log.debug("View Changed: ", view.visStart, view.visEnd, view.start, view.end);
                        }
                      }
                    };
                    scope.contentCreateModal = "";
                    scope.eliminarMod = "";
                    scope.initPopup = function(date){
                    	scope.msgokModal = "";
		                scope.contentCreateModal = $uibModal.open({
		                      animation: true,
		                      ariaLabelledBy: 'modal-title-top',
		                      ariaDescribedBy: 'modal-body-top',
		                      templateUrl: 'calendariogastos.html',
		                      size: 'lg',
		                      controller: function($scope) {
		                      	$scope.date = date;
		                        $scope.okForm = function(){
		                            scope.addCalaus(date);
		                            scope.contentCreateModal.close();
		                        }
		                        $scope.koForm = function(){
		                            scope.contentCreateModal.close();
		                        }
		                        $scope.delForm = function(){
		                            scope.contentCreateModal.close();
		                            scope.eliminarMod = $uibModal.open({
					                      animation: true,
					                      ariaLabelledBy: 'modal-title-top',
					                      ariaDescribedBy: 'modal-body-top',
					                      templateUrl: 'eliminar.html',
					                      size: 'lg',
					                      controller: function($scope) {
					                      	$scope.date = date;
					                        $scope.elimOk = function(){
					                        	//elkiminar
					                        	console.log(scope.calendar);
					                        	CalendariogastoService.eliminarGasto(date.id,function(data){
			                                        scope.calendar.refetchEvents();
			                                        scope.uiConfig.calendar.viewRender(scope.calendar.getView(),element);
					                            	scope.eliminarMod.close();
					                            });
					                        }
					                        $scope.elimKo = function(){
					                            scope.eliminarMod.close();
					                        }
					                      }
					                });
		                        }
		                      }
		                });
                    }



                    scope.contentCreateAdd = "";
                    scope.addCalaus = function(date){
                    	 scope.contentCreateAdd = $uibModal.open({
		                      animation: true,
		                      ariaLabelledBy: 'modal-title-top',
		                      ariaDescribedBy: 'modal-body-top',
		                      templateUrl: 'addcal.html',
		                      size: 'lg',
		                      controller: function($scope) {
		                      	$scope.control = scope.control;
		                      	$scope.msg = "";
		                      	if(date!=null){
		                      		scope.control.camposActual = {};
		                      		scope.control.camposActual.id = date.id;
		                      		scope.control.camposActual.fecha = date.fecha;
                            		scope.control.camposActual.importe = date.importe;
                            		scope.control.camposActual.moneda = date.moneda;
                            		scope.control.camposActual.file_id = date.file_id;
                            		scope.control.camposActual.concepto_texto = date.concepto_texto;
                            		scope.control.camposActual.conceptogasto_id = date.conceptogasto_id;
                            		scope.control.camposActual.pagogasto_id = date.pagogasto_id;
		                      	}else{
		                      		scope.control.camposActual = {};
		                      		scope.control.camposActual.id = "";
		                      		scope.control.camposActual.fecha = "";
                            		scope.control.camposActual.importe = "";
                            		scope.control.camposActual.moneda = "€";
                            		scope.control.camposActual.concepto_texto = "";
                            		scope.control.camposActual.conceptogasto_id = "";
                            		scope.control.camposActual.pagogasto_id = "";
		                      	}
		                      	console.log($scope.control);
		                        $scope.okForm = function(){
		                        	console.log(scope.control);
		                            CalendariogastoService.guardarCalendariogasto(scope.control.camposActual,function(data){
		                            	//scope.calendar.fullCalendar('refetchEvents');
		                            	if(data.code==1){
	                                        scope.calendar.refetchEvents();
	                                        scope.uiConfig.calendar.viewRender(scope.calendar.getView(),element);
			                            	scope.contentCreateAdd.close();
			                            }else{
			                            	$scope.msg = data.msg;
			                            }
		                            	
		                            });
		                        }
		                        $scope.koForm = function(){
		                            scope.contentCreateAdd.close();
		                        }
		                    }
		                });
                    }


                    scope.contentCerrarFecha = "";
                    scope.cerrarMes = function(){
                    	 scope.contentCerrarFecha = $uibModal.open({
		                      animation: true,
		                      ariaLabelledBy: 'modal-title-top',
		                      ariaDescribedBy: 'modal-body-top',
		                      templateUrl: 'cerrarmes.html',
		                      size: 'lg',
		                      controller: function($scope) {
		                      	$scope.cerrar = scope.cerrar;
		                        $scope.mesOk = function(){
		                        	CalendariogastoService.cerrarMes(scope.cerrar.fecha,function(data){
                                        scope.calendar.refetchEvents();
                                        scope.uiConfig.calendar.viewRender(scope.calendar.getView(),element);
		                            	scope.contentCerrarFecha.close();
		                            	
		                            });
		                        }
		                        $scope.mesKo = function(){
		                            scope.contentCerrarFecha.close();
		                        }
		                    }
		                });
                    }

                    scope.calendarClick = function( date, jsEvent, view){
                    	console.log("entro");
                        /*console.log(date);
                        console.log(jsEvent);
                        console.log(view);*/
                    }
                   
                });
            }
          }
      }
})();